import { useContext, useMemo, FC, } from 'react';
// 组件
import SuperForm from '../../../../SuperForm';
// 方法
import StrategyCountext from '../../../context/strategyCountext';
import { getFormItems } from './util';
// 常量
import { StrategyPageLeftProps } from '../../../interface';

const Left: FC<StrategyPageLeftProps> = props => {
  const { disabled, ruleFormRef, } = props;
  const { ruleFormItems, optionalFormItems, optionalFormRef, dispatch, } = useContext(StrategyCountext);
  const handleChange = (name: string, checkedValue: any[]) => {
    dispatch('changeFormItem', { groupOptions: {name, value: checkedValue}, });
  };
  const formItems = useMemo(() => {
    const newFormItem = getFormItems(optionalFormItems, handleChange);
    return newFormItem;
  }, [optionalFormItems]);
  return (
    <div className="yb-StrategyPage-left yb-StrategyPage-item">
      <SuperForm
        actionRef={ruleFormRef}
        testId='strategy-page-left-1'
        style={{borderBottom: 'dashed 1px #e9ecef'}}
        formItems={ruleFormItems}
        defaultLineNumber={1}
        defaultLabelCol={{span: 8}}
        disabled={disabled}
      />
      <SuperForm
        actionRef={optionalFormRef}
        testId='strategy-page-left-2'
        className='optional-form'
        formItems={formItems}
        defaultLineNumber={1}
        defaultLabelCol={{span: 8}}
        disabled={disabled}
      />
    </div>
  );
};

export default Left;
